import { render, staticRenderFns } from "./OutcomeSrsStep.vue?vue&type=template&id=32e05dcb"
import script from "./OutcomeSrsStep.vue?vue&type=script&lang=js"
export * from "./OutcomeSrsStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports